var _path, _path2, _path3, _path4, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLely(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 34,
    viewBox: "0 0 26 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5181 15.2262C6.10483 15.2262 0.90625 12.0047 0.90625 8.03142C0.90625 4.05791 6.10483 0.836426 12.5181 0.836426C18.9309 0.836426 24.1296 4.05791 24.1296 8.03142C24.1296 12.0047 18.9309 15.2262 12.5181 15.2262Z",
    fill: "#C30A14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9576 11.3043L13.0884 10.0322L13.0896 5.99527L14.4438 5.41614V9.48006L15.9565 10.0746L15.9576 11.3043Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8174 6.99879L10.843 6.68865L10.8447 7.54925L11.8094 7.71834L11.8091 8.36381L10.8447 8.53105L10.8425 9.30587L11.8174 8.94113L11.8173 9.96077L9.75488 10.8933L9.75603 5.11255L11.8174 5.99661V6.99879Z",
    fill: "#FFFFFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02127 11.2251L5.7627 12.695V3.40125L7.2587 4.04631L7.26038 10.6448L9.02127 9.98888V11.2251Z",
    fill: "#FFFFFE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H25.0012V16.0479H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.38 12.3785L16.9059 11.7255V8.47638L15.2446 5.0764L16.2627 4.63836L17.3912 6.94932L18.1318 3.83933L19.4927 3.26038L18.3806 8.15821L18.38 12.3785Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5181 15.2262C6.10479 15.2262 0.906206 12.0047 0.906206 8.03139C0.906206 4.05789 6.10479 0.8364 12.5181 0.8364C18.9308 0.8364 24.1295 4.05789 24.1295 8.03139C24.1295 12.0047 18.9308 15.2262 12.5181 15.2262ZM12.4992 0C5.59426 0 -0.00292969 3.59267 -0.00292969 8.02397C-0.00292969 12.4551 5.59426 16.0479 12.4992 16.0479C19.4035 16.0479 25.0009 12.4551 25.0009 8.02397C25.0009 3.59267 19.4035 0 12.4992 0Z",
    fill: "#FFFFFE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLely);
export default __webpack_public_path__ + "static/media/logo-lely.e221ac69.svg";
export { ForwardRef as ReactComponent };